import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UserService } from '../../../core/services/user/user.service';

interface MenuItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatNavList,
    MatListItem,
    MatIcon,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  public readonly menuItems: MenuItem[] = [
    { label: 'Портали', route: '/portals', icon: 'language' },
    { label: 'Міста', route: '/cities', icon: 'location_city' },
    { label: 'Регіони', route: '/regions', icon: 'map' },
    { label: 'Компетенції', route: '/competences', icon: 'psychology' },
    { label: 'Імпорт профілів', route: '/import-profiles', icon: 'upload' },
    { label: 'Міграції', route: '/migrations', icon: 'storage' },
    { label: 'Компетенції: i18n', route: '/competence-i18n', icon: 'translate' },
    { label: 'Управління кешем', route: '/cache-management', icon: 'cached' },
    { label: 'Управління файлами', route: '/file-management', icon: 'folder' },
    { label: 'Керування контактами', route: '/contact-management', icon: 'contacts' },
    { label: 'Вакансії: обслуговування', route: '/vacancy-maintenance', icon: 'work_history' },
    { label: 'M2M токени', route: '/m2m-tokens', icon: 'vpn_key' },
  ];

  public logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  get currentUser() {
    return this.userService.user$.value;
  }
}
